"use client"

import { Link, useNavigate } from "react-router-dom"
import { useContext } from "react"
import { AuthContext } from "../../context/AuthContext"
import Logo from "../Layout/img/u2lr.jpeg"

export default function Navbar() {
  const { user, logout } = useContext(AuthContext)
  const navigate = useNavigate()

  const handleLogout = () => {
    logout()
    setTimeout(() => {
       navigate("/login")
    }, 3000);
  }

  return (
    <>
      <style>{`
        .navbar-custom {
          background: linear-gradient(135deg, rgba(15, 23, 42, 0.95) 0%, rgba(17, 24, 39, 0.95) 100%);
          border-bottom: 1px solid rgba(79, 70, 229, 0.2);
          backdrop-filter: blur(20px);
          box-shadow: 0 4px 24px rgba(0, 0, 0, 0.1);
          padding: 0.75rem 0;
          position: sticky;
          top: 0;
          z-index: 1000;
        }
        
        .navbar-brand-custom {
          font-size: 1.5rem;
          font-weight: 700;
          letter-spacing: -0.5px;
          background: #fff;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }
        
        .navbar-brand-custom:hover {
          filter: brightness(1.2);
          transform: translateY(-1px);
        }
        
        .brand-icon {
          width: 32px;
          height: 32px;
          background: ;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-weight: 700;
          font-size: 1.2rem;
          box-shadow: 0 2px 8px rgba(79, 70, 229, 0.3);
        }
        
        .nav-greeting {
          color: #E5E7EB;
          font-size: 0.95rem;
          margin: 0;
          display: flex;
          align-items: center;
          gap: 0.5rem;
          padding: 0.5rem 1rem;
          background: rgba(70, 115, 229, 0.1);
          border-radius: 8px;
          border: 1px solid rgb(255, 255, 255);
        }
        
        .nav-greeting strong {
          color: #ffffff;
          font-weight: 600;
        }
        
        .user-avatar {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background: linear-gradient(135deg, #4F46E5 0%, #22C55E 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-weight: 600;
          font-size: 0.9rem;
          box-shadow: 0 2px 8px rgba(79, 70, 229, 0.3);
        }
        
        .btn-nav-outline {
          border: 2px solid rgba(255, 255, 255, 0.5);
          color: #4F46E5;
          font-weight: 500;
          padding: 0.5rem 1.25rem;
          border-radius: 8px;
          transition: all 0.3s ease;
          background: transparent;
          position: relative;
          overflow: hidden;
        }
        
        .btn-nav-outline::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: rgba(79, 70, 229, 0.1);
          transition: left 0.3s ease;
          z-index: -1;
        }
        
        .btn-nav-outline:hover::before {
          left: 0;
        }
        
        .btn-nav-outline:hover {
          border-color: #ffffff;
          color: #ffffff;
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(255, 255, 255, 0.3);
        }
        
        .btn-nav-primary {
          background: linear-gradient(135deg, #1130df 0%, #171b23 100%);
          color: white;
          font-weight: 600;
          padding: 0.5rem 1.5rem;
          border-radius: 8px;
          border: 2px solid transparent;
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
        }
        
        .btn-nav-primary::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          opacity: 0;
          transition: opacity 0.3s ease;
        }
        
        .btn-nav-primary:hover::before {
          opacity: 1;
        }
        
        .btn-nav-primary:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(255, 255, 255, 0.4);
        }
        
        .btn-nav-logout {
          border: 2px solid rgba(239, 68, 68, 0.5);
          color: #EF4444;
          font-weight: 500;
          padding: 0.5rem 1.25rem;
          border-radius: 8px;
          transition: all 0.3s ease;
          background: transparent;
        }
        
        .btn-nav-logout:hover {
          border-color: #EF4444;
          background: rgba(239, 68, 68, 0.1);
          color: #EF4444;
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);
        }
        
        .navbar-toggler {
          border: 2px solid #fff;
          padding: 0.5rem;
          border-radius: 8px;
          transition: all 0.3s ease;
        }
        
        .navbar-toggler:hover {
          border-color: rgba(255, 255, 255, 0.5);
          background: rgba(79, 70, 229, 0.1);
        }
        
        .navbar-toggler:focus {
          box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.25);
        }
        
        .navbar-toggler-icon {
          background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgb(255, 255, 255)' strokeLinecap='round' strokeMiterlimit='10' strokeWidth='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
        }
        
        .navbar-nav {
          gap: 0.5rem;
        }
        
        @media (max-width: 991px) {
          .navbar-nav {
            padding-top: 1rem;
          }
          
          .nav-item {
            width: 100%;
          }
          
          .btn-nav-outline,
          .btn-nav-primary,
          .btn-nav-logout {
            width: 100%;
            text-align: center;
          }
          
          .nav-greeting {
            margin-bottom: 0.5rem;
          }
        }
      `}</style>

      <nav className="navbar navbar-expand-lg navbar-dark navbar-custom">
        <div className="container">
          <Link to="/" className="navbar-brand navbar-brand-custom">
            <img src={Logo} className="brand-icon" alt="u2lr link Shortener"/>
            <span>u2lr</span>
            {/* <span style={{fontSize: "20px"}}>Link Shortener</span> */}
          </Link>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarContent"
            aria-controls="navbarContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarContent">
            <ul className="navbar-nav ms-auto align-items-lg-center">
              {user ? (
                <>
                  <li className="nav-item me-lg-3">
                    <span className="nav-link nav-greeting">
                      <span className="user-avatar">{user.userName.charAt(0).toUpperCase()}</span>
                      <span>
                        Hello, <strong>{user.userName}</strong>
                      </span>
                    </span>
                  </li>

                  <li className="nav-item">
                    <Link to="/user-dashboard" className="btn btn-nav-outline btn-sm">
                      Dashboard
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/u2lr-products" className="btn btn-nav-outline btn-sm">
                    u2lr products
                    </Link>
                  </li>

                  <li className="nav-item">
                    <Link to="/contact-us" className="btn btn-nav-outline btn-sm">
                      Contact Us
                    </Link>
                  </li>

                  <li className="nav-item">
                    <button onClick={handleLogout} className="btn btn-nav-logout btn-sm">
                      Logout
                    </button>
                  </li>
                </>
              ) : (
                <>
                <li className="nav-item">
                  <Link to="/about-us" className="btn btn-nav-outline btn-sm">
                    About Us
                  </Link>
                </li>

                <li className="nav-item">
                  <Link to="/u2lr-pricing" className="btn btn-nav-outline btn-sm">
                    Pricing
                  </Link>
                </li>
                  <li className="nav-item">
                  <Link to="/u2lr-products" className="btn btn-nav-outline btn-sm">
                   u2lr products
                  </Link>
                </li>

                <li className="nav-item">
                  <Link to="/login" className="btn btn-nav-outline btn-sm">
                    Login
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/register" className="btn btn-nav-primary btn-sm">
                    Register
                  </Link>
                </li>
              </>

              )}
            </ul>
          </div>
        </div>
      </nav>
    </>
  )
}
